export default {
    data: () => ({
        translations: {
            title: {
                el: "ΑΦΜ / Elorus",
                en: "VAT / Elorus",
                it: "IVA / Elorus"
            },
            description: {
                el: "Επεξεργαστείτε το ΑΦΜ και Elorus client id της εταιρείας.",
                en: 'Edit the VAT and Elorus client id of the company.',
                it: "Modificare la partita IVA e l'id cliente Elorus dell'azienda."
            },
            vat: {
                el: "ΑΦΜ",
                en: "VAT",
                it: "IVA"
            },
            errorMessage: {
                el: "Τόσο το TIN όσο και το Elurus Client Id είναι άκυρα",
                en: "Both TIN and Elurus Client Id are invalid",
                it: "Sia il TIN che l'ID cliente Elurus non sono validi."
            },
            successMessageTin: {
                el: "Το ΑΦΜ ενημερώθηκε με επιτυχία.",
                en: "TIN was updated successfully.",
                it: "Il TIN è stato aggiornato con successo."
            },
            successMessageElorus: {
                el: "Το Elurus Client ενημερώθηκε με επιτυχία.",
                en: "Elurus Client was updated successfully.",
                it: "Il client Elurus è stato aggiornato con successo."
            },
            successMessageTinElorus: {
                el: "Τόσο το TIN όσο και το Elurus Client ενημερώθηκαν με επιτυχία",
                en: "Both TIN and Elurus Client were updated successfully",
                it: "Sia il TIN che il client Elurus sono stati aggiornati con successo."
            },
            errorTinRequired: {
                el: "Απαιτείται Αριθμός ΑΦΜ",
                en: "Vat Number is required",
                it: "È richiesto il numero di partita IVA"
            },
            errorTinLength: {
                el: "Ο Αριθμός ΑΦΜ πρέπει να έχει 9 με 12 χαρακτήρες",
                en: "Vat Number must be 9 to 12 characters long",
                it: "Il numero di partita IVA deve essere lungo 9 a 12 caratteri"
            },
        }
    })
};
